var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslations } from '../../../features/providers/translations-provider';
import { buildHubspotMeetingUrl } from '../../../utils/hubspot/meeting-url';
import Button from '../../common/button';
const HubspotMeeting = (_a) => {
    var { meetingUrl, additionalParams = {}, isOnboarding } = _a, props = __rest(_a, ["meetingUrl", "additionalParams", "isOnboarding"]);
    const { t } = useTranslations();
    const meetingUrlWithProps = useMemo(() => {
        return buildHubspotMeetingUrl(meetingUrl, props, additionalParams);
    }, [props, additionalParams, meetingUrl]);
    return (_jsx(Button, { size: isOnboarding ? 'small' : 'medium', shape: isOnboarding ? 'rounded-corner' : undefined, variant: "navigation", onClick: () => {
            window.open(meetingUrlWithProps, '_blank');
        }, withArrowRight: true, children: t('clientDashboard|dashboardBookMeetingCta') }));
};
export default HubspotMeeting;
